import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementServiceReserveFormCalendar`;


const ApiAmusementCalendar = {
  getAll: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementServiceReserveFormTemplateByServiceId`;
    return ServiceApi.get(url, { params });
  },
  reservationFormExpirationReport: (params) => {
    const url = `${baseServiceUrl}/reservationFormExpirationReport`;
    return ServiceApi.get(url, { params });
  },
  changeStatusHallEventCalendars: (params) => {
    const url = `${baseServiceUrl}/changeStatusHallEventCalendars`;
    return ServiceApi.post(url, params);
  }
};

export default ApiAmusementCalendar;


